module.exports = "/_next/static/images/bri_ic-96e6fd5d76cab09009be709dcbb0806b.svg";